import { branchLiveStates } from '@ourbranch/lookups';
const brand = {
    constants: {
        SHORT_NAME: 'Branch',
        FULL_NAME: 'Branch Insurance',
        LEGAL_NAME: 'Branch Insurance Exchange',
        EMAIL_SENDER: 'Branch Insurance',
        EMAIL_BCC: 'sendgridbcc@ourbranch.com',
        SUPPORT_NAME: 'Branch Insurance',
        DOMAIN: 'ourbranch.com',
        SUPPORT_EMAIL: 'support@ourbranch.com',
        DISPLAY_NAME: 'Branch',
        MARKETING_NAME: 'Branch Insurance',
        POLICY_ISSUER: 'Branch Insurance Exchange',
        CLAIMS_HANDLER: 'Branch',
        REFERRAL_NAME: 'Branch Insurance',
        SOCIAL_HANDLE: 'Branch',
        PAYMENT_ADDRESS: 'Branch Payments, PO Box 15010, Worcester, MA 01615',
        EXPEDITED_PAYMENT_ADDRESS: 'Branch c/o Covenir, 370 Main St, Suite 880, Worcester, MA 01608',
        CUSTOMER_SERVICE_PHONE: '833-427-2624',
        CUSTOMER_SERVICE_PHONE_LETTERS: '833-4BRANCH',
        SUPPORT_RENEWAL_AND_CANCEL_QUESTIONS_PHONE: '(855)-236-6302',
        CLAIMS_PHONE: '(855)-223-9294',
        CLAIMS_EMAIL: 'claimsupport@ourbranch.com',
        AGENCY_SUPPORT_EMAIL: 'agencysupport@ourbranch.com',
        AGENCY_SUPPORT_PHONE: '(855) 438-5411',
        AGENCY_SUPPORT_HOURS: 'Mon-Fri, 9am-7pm EST',
        MEMBER_COMMS_EMAIL: 'membercomms@ourbranch.com',
        SMS_SHORTCODE: '230230',
        PRIVACY_POLICY_URL: 'https://www.ourbranch.com/s/blog/privacy-policy',
        TERMS_OF_USE_URL: 'https://www.ourbranch.com/s/blog/terms-of-use',
        COMMUNICATIONS_CONSENT_URL: 'https://www.ourbranch.com/s/blog/communication-consent/',
        IOS_APP_STORE_URL: 'https://apps.apple.com/us/app/branch-insurance/id1437502167',
        ANDROID_GOOGLE_PLAY_STORE_URL: 'https://play.google.com/store/apps/details?id=com.branch.accountmobile'
    },
    theme: {
        palette: null,
        loaderColor: '#527059',
        showLogoInLoader: true,
        showAccountBackgroundHero: true,
        logoWidthDesktop: 320,
        logoWidthMobile: 230,
        logoVerticalWidthDesktop: 124,
        logoVerticalWidthMobile: 102
    },
    config: {
        supportedStates: branchLiveStates,
        // Branch keeps the legacy "rateControlDate must be today" rule (issue #32130).
        rateControlDate: { maxStaleDaysToBind: 0, underwriterMaxHoldDays: 0 }
    }
};
export const constants = brand.constants;
export const theme = brand.theme;
export default brand.config;
